/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import ValidatorSelect from "../../../Validator/ValidatorSelect";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { Vehicle as VehicleType } from "../../../../types/ProcessCostSupport";
import { UseForm } from "../../../../types/UseForm";

type VehicleProps = {
  path: string;
  vehicle: VehicleType;
  handleChange: UseForm["handleChange"];
};

const Vehicle = ({ path, vehicle, handleChange }: VehicleProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Bitte geben Sie hier weitere Details zum Fahrzeug an.
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          fullWidth={true}
          name={path + ".make"}
          label="Marke und Typ"
          margin="normal"
          value={vehicle.make}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          fullWidth={true}
          name={path + ".manufactured"}
          label="Baujahr"
          margin="normal"
          value={vehicle.manufactured}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          fullWidth={true}
          name={path + ".purchased"}
          label="Anschaffungsjahr"
          margin="normal"
          value={vehicle.purchased}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorSelect
          label={"Allein- oder Miteigentum"}
          fullWidth
          value={vehicle.ownership}
          onChange={handleChange}
          name={path + ".ownership"}
          inputProps={{
            name: path + ".ownership",
          }}
          MenuProps={{
            slotProps: {
              paper: {
                sx: { maxHeight: 200 },
              },
            },
          }}
        >
          <MenuItem value={"Alleineigentum"}>Alleineigentum</MenuItem>
          <MenuItem value={"Miteigentum"}>Miteigentum</MenuItem>
        </ValidatorSelect>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorNumberField
          fieldType={"kilometers"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".mileage"}
          label="Kilometerstand"
          margin="normal"
          value={vehicle.mileage}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          fullWidth={true}
          name={path + ".value"}
          label="Verkehrswert"
          margin="normal"
          value={vehicle.value}
          helperText={
            "Gemeint ist dabei der Preis, der jetzt bei einem Verkauf erzielt werden kann. Nutzen Sie z.B. www.autoscout24.de um den Preis schätzen zu können."
          }
          onChange={handleChange}
        />
      </Grid>
    </>
  );
};

export default Vehicle;
